export const flattenQueryParams = (queryParams?: Record<string, any>) => {
  const { filters = {}, pagination = {} } = queryParams || {};

  const params: Record<string, string> = {}; // Ensure all values are strings

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params[key] = value.toString();
    }
  });

  Object.entries(pagination).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params[key] = value.toString();
    }
  });

  return params;
};

export function getErrorMessage(err: any) {
  const errorObj = err?.data;

  if (errorObj) {
    return (
      errorObj?.error ||
      errorObj?.message?.fieldErrors?.[0]?.message ||
      errorObj?.message ||
      (Array.isArray(errorObj) ? errorObj[0]?.message : null) ||
      errorObj.error ||
      "An unexpected error occurred"
    );
  }
}
